import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=fa60c88c&scoped=true&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"
import style0 from "./Search.vue?vue&type=style&index=0&id=fa60c88c&lang=scss&scoped=true&"
import style1 from "./Search.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa60c88c",
  null
  
)

export default component.exports